// extracted by mini-css-extract-plugin
export default {"outlinedSelect":"PeriodDropdown_outlinedSelect__8kkCY","standardSelect":"PeriodDropdown_standardSelect__Dx2kB","selectMenu":"PeriodDropdown_selectMenu__gGn5b"};